import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { Row, Col, Image, Statistic } from "antd";
import { getStatTotal } from '../../../http/manager';
import { RiseOutlined } from '@ant-design/icons';
import CountUp from 'react-countup';

import icon1 from '../../../image/static-icon1.png';
import icon2 from '../../../image/static-icon2.png';
import icon3 from '../../../image/static-icon3.png';
import icon4 from '../../../image/static-icon4.png';

const StaticsContent: React.FC = () => { 
    const [totalData, setTotalData] = useState({
        total: 0,
        totalAtlas: 0,
        totalDna: 0,
        totalImage: 0,
        totalImageUp: 0,
        totalModel: 0,
        totalModelUp: 0,
        totalPlantImage: 0,
        totalPopular: 0,
        totalPopularUp: 0,
        totalSpecimen: 0,
        totalUp: 0
    })
    useEffect(()=> {
        getStatistics();
        return;
    }, [])
    const getStatistics = ()=> {
        getStatTotal({}).then((res: any)=> {
            setTotalData(res.data)
        })
    }
    return (
        <StatisticsConent>
            <Row gutter={24} style={{ backgroundColor: '#fff' }}>
                <Col span={6} className={'item'}>
                    <div className="content" style={{ backgroundImage: `url(${require('../../../image/bg1.png')})` }}>
                        <CountUp className="num" end={ totalData.total }></CountUp>
                        <div className="name">
                            <p>系统总记录数</p>
                            <p className="number">较昨日 +<CountUp end={ totalData.totalUp }></CountUp></p>
                            <RiseOutlined />
                        </div>
                    </div>
                    <div className="static-content">
                        <Image
                            preview={false}
                            width={48}
                            src={icon1}
                        />
                        <div className="right">
                            <CountUp className="sNum" end={ totalData.totalSpecimen }></CountUp>
                            <p className="sName">腊叶标本数</p>
                        </div>
                    </div>
                </Col>
                <Col span={6} className="item">
                    <div className="content" style={{ backgroundImage: `url(${require('../../../image/bg2.png')})` }}>
                        <CountUp className="num" end={ totalData.totalImage }></CountUp>
                        <div className="name">
                            <p>图片数量</p>
                            <p className="number">较昨日 +<CountUp end={ totalData.totalImageUp }></CountUp></p>
                            <RiseOutlined />
                        </div>
                    </div>
                    <div className="static-content">
                        <Image
                            preview={false}
                            width={48}
                            src={icon2}
                        />
                        <div className="right">
                            <CountUp className="sNum" end={ totalData.totalPlantImage }></CountUp>
                            <p className="sName">原植物图库记录数</p>
                        </div>
                    </div>
                </Col>
                <Col span={6} className="item">
                    <div className="content" style={{ backgroundImage: `url(${require('../../../image/bg3.png')})` }}>
                        <CountUp className="num" end={ totalData.totalModel }></CountUp>
                        <div className="name">
                            <p>模型数量</p>
                            <p className="number">较昨日 +<CountUp end={ totalData.totalModelUp }></CountUp></p>
                            <RiseOutlined />
                        </div>
                    </div>
                    <div className="static-content">
                        <Image
                            preview={false}
                            width={48}
                            src={icon3}
                        />
                        <div className="right">
                            <CountUp className="sNum" end={ totalData.totalAtlas }></CountUp>
                            <p className="sName">图谱记录数</p>
                        </div>
                    </div>
                </Col>
                <Col span={6} className="item">
                    <div className="content" style={{ backgroundImage: `url(${require('../../../image/bg4.png')})` }}>
                        <CountUp className="num" end={ totalData.totalPopular }></CountUp>
                        <div className="name">
                            <p>文章数量</p>
                            <p className="number">较昨日 +<CountUp end={ totalData.totalPopularUp }></CountUp></p>
                            <RiseOutlined />
                        </div>
                    </div>
                    <div className="static-content">
                        <Image
                            preview={false}
                            width={48}
                            src={icon4}
                        />
                        <div className="right">
                            <CountUp className="sNum" end={ totalData.totalDna }></CountUp>
                            <p className="sName">DNA序列记录数</p>
                        </div>
                    </div>
                </Col>
            </Row>
        </StatisticsConent>
    )
}

export default observer(StaticsContent);
const StatisticsConent = styled.div`
  & {
    margin: 15px 15px 0;
    padding: 15px;
    background: #fff;
    .item {
        padding-bottom: 36px;
        color: #fff;
        display: flex;
        flex-direction: column;
    }
    .content {
        padding: 50px 20px 0;
        width: 100%;
        background-size: 100% 100%;
    }
    .name {
        display: flex;
        justify-content: space-between;
    }
    .number {
        flex: 1;
        padding-right: 8px;
        text-align: right;
    }
    .num {
        margin: 0;
        font-size: 36px;
    }
    .static-content {
        margin-top: 45px;
        padding-left: 20%;
        display: flex;
        align-items: center;
    }
    .right {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .sNum {
        margin: 0;
        font-size: 28px;
        color: #4C77FA;
    }
    .sName {
        margin: 0;
        font-size: 14px;
        color: rgba(0,0,0,0.85);
    }
  }
`